import {
  Button,
  Divider,
  InputBase,
  InputAdornment,
  IconButton,
  Checkbox,
  Select,
  MenuItem,
  CircularProgress,
  Box,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import {
  DeleteOutline,
  ErrorOutline,
  KeyboardArrowDown,
  PhoneForwarded,
  PlayCircleFilledOutlined,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import RequireTwilioAccountModal from "../../modals/RequireTwilioAccountModal";
import { json, useNavigate } from "react-router-dom";
import axios from "axios";
import validator from "validator";
import { jwtDecode } from "jwt-decode";
import SigninWithGoogle from "../SigninWithGoogle";
import generatecode from "../../utils/generateCode";
import CryptoJS from "crypto-js";
import { formatPhoneNumber } from "../../utils/formatnumber";
import posthog from "posthog-js";
import decryptApi from "../../utils/decryptApi";
import encryptApi from "../../utils/encryptApi";

const Register = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [step, setStep] = useState(1);
  const [forward_action, setSelectedForwardAction] = useState(1);
  const [openRequireModal, setOpenRequireModal] = useState(false);
  const [errorMsg, setErrormsg] = useState(null);
  const [codeSent, setCodeSent] = useState(false)

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  //user information
  const [user, setUser] = useState({
    organization_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    userId: JSON.parse(localStorage.getItem('user'))?.userId?.S || null,
    email: JSON.parse(localStorage.getItem('user'))?.email?.S || null,
    password: JSON.parse(localStorage.getItem('user'))?.password?.S || null,
    first_name: JSON.parse(localStorage.getItem('user'))?.fName?.S || null,
    last_name: JSON.parse(localStorage.getItem('user'))?.lName?.S || null,
    company_name: JSON.parse(localStorage.getItem('organization'))?.organization_name?.S || null,
    agreed: false,
    registeredFromGoogle: JSON.parse(localStorage.getItem('user'))?.registeredFromGoogle?.BOOL || false
  });

  //twilio information
  const [twilio_information, setTwilioInformation] = useState({
    organization_id: JSON.parse(localStorage.getItem("organization"))?.orgId?.S,
    account_sid: "",
    api_key: "",
    transcription_enabled: false,
    test_account: false,
    auto_configuration: true,
    primary_phone: "select",
  });

  // const [twilio_information, setTwilioInformation] = useState({
  //   organization_id: JSON.parse(localStorage.getItem("organization"))?.orgId?.S,
  //   account_sid: "AC54ba1f0164c838f321e1b0ec76ac42d2",
  //   api_key: "cf9df885bd2af6d13aacb44b726e42e2",
  //   transcription_enabled: false,
  //   test_account: false,
  //   auto_configuration: true,
  //   primary_phone: "select",
  // });

  //phone numbers
  const [incomming_phonenumbers, setIncommingPhonenumbers] = useState(null);

  //register function

  useEffect(() => {

    if (user && user.registeredFromGoogle) {
      localStorage.clear()
    }

  }, [user])

  const registerUser = async () => {
    console.log('organization_timezone',user.organization_timezone)

    let err = false;
    if (!user.agreed) {
      setErrormsg("Please accept the terms of service.");
      err = true;
    }

    if (!validator.isEmail(user.email)) {
      setErrormsg("Please fill in a valid email");
      err = true;
    }

    if (!user.first_name || user.first_name.length < 1) {
      setErrormsg("Please fill in first name");
      err = true;
    }

    if (!user.last_name || user.last_name.length < 1) {
      setErrormsg("Please fill in last name");
      err = true;
    }

    if (!user.company_name || user.company_name.length < 1) {
      setErrormsg("Please fill in company name");
      err = true;
    }

    if (!user.password || user.password.length < 4) {
      setErrormsg("password length should be 4 or more");
      err = true;
    }

    if (!err) {
      setErrormsg(null);
      setLoader(true);

      try {

        if (user.registeredFromGoogle) {
          console.log(user)
          await axios
            .post(process.env.REACT_APP_BACKEND_URL + "user/add-created-user-to-org", user)
            .then((res) => {
              console.log(res)
              if (res.data.status === "success") {
                localStorage.setItem("user", JSON.stringify(res.data.user)); //store user data in local storage
                localStorage.setItem(
                  "organization",
                  JSON.stringify(res.data.organization)
                ); //stores organization datat in local storage
                setStep(step + 1);
                //post hog track event for signUp
                posthog.capture('Signed up', {
                  email: res.data.user.email.S,
                  userId: res.data.user.userId.S
                });
                setLoader(false);
              } else {
                setErrormsg(`${res.data.msg}`);
                setLoader(false);
              }
            })
            .catch((err) => {
              setLoader(false);
            });
        } else {
          await axios
            .post(process.env.REACT_APP_BACKEND_URL + "create-user", user)
            .then((res) => {

              if (res.data.status === "success") {
                localStorage.setItem("user", JSON.stringify(res.data.user)); //store user data in local storage
                localStorage.setItem(
                  "organization",
                  JSON.stringify(res.data.organization)
                ); //stores organization datat in local storage
                setStep(step + 1);
                //post hog track event for signUp
                posthog.capture('Signed up', {
                  email: res.data.user.email.S,
                  userId: res.data.user.userId.S
                });
              
                setLoader(false);
              } else {
                setErrormsg(`Error, account for ${user.email} already exists.`);
                setLoader(false);
              }
            })
            .catch((err) => {
              setLoader(false);
            });
        }
      } catch (error) {
        console.log(error);
        if (error.response && error.response.data) {
          console.error("Response data:", error.response.data);
          setErrormsg(error.response.data.message);
        }
        setLoader(false);
      }
    }
  };



  const addTwilioInformation = async () => {
    if (!validator.isMobilePhone(twilio_information.primary_phone)) {
      setErrormsg(
        "issues with credentials. Please select a primary phone number"
      );
    } else {
      setLoader(true);
      console.log(JSON.parse(localStorage.getItem("organization"))?.orgId?.S);
      try {
        let t = twilio_information;
        await axios
          .post(
            process.env.REACT_APP_BACKEND_URL + "add-org-twilio_information",
            {
              ...t,
              organization_id: JSON.parse(localStorage.getItem("organization"))
                ?.orgId?.S,
            }
          )
          .then((res) => {
            if (res.data.status === "success") {
              console.log(res.data);
              localStorage.setItem(
                "organization",
                JSON.stringify(res.data.organization)
              ); //stores organization datat in local storage
              setLoader(false);
              setStep(step + 1);
            } else {
              setErrormsg("Some error occured , try again");
              setLoader(false);
            }
          })
          .catch((err) => {
            console.log(err);
            if (err.response && err.response.data) {
              console.error("Response data:", err.response.data);
              setErrormsg(err.response.data.message);
            }
            setLoader(false);
          });
      } catch (error) {
        console.log(error);
        if (error.response && error.response.data) {
          console.error("Response data:", error.response.data);
          setErrormsg(error.response.data.message);
        }
        setLoader(false);
      }
    }
  };

  // forward number
  const [forward_number, setForwardNumber] = useState("");
  const [verificationCode, setVerificationCode] = useState(null);
  const [verificationCodeConfirmation, setVerificationCodeConfirmation] =
    useState(null);

  //verify phone number
  const [loader2, setLoader2] = useState(false);
  const [code, setCode] = useState(null)
  const [timeLeft, setTimeLeft] = useState(0);

  useEffect(() => {
    setCode(generatecode())
    setCodeSent(false)

  }, [forward_number])



  useEffect(() => {
    if (timeLeft <= 0) return;

    const intervalId = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    if (timeLeft === 0) {
      setCode(generatecode())
    }
    return () => clearInterval(intervalId); // Cleanup on unmount or re-render
  }, [timeLeft]);
  async function sendPhoneVerificationText() {
    setErrormsg(null);

    setLoader(true);
    try {
      const ciphertext = CryptoJS.AES.encrypt(code, process.env.REACT_APP_TWILANSWER_SECRET).toString();
      console.log({ ciphertext })
      console.log({ code })
      let response = await axios.post(
        process.env.REACT_APP_BACKEND_URL +
        "twilio/read-num-aloud",
        {
          fromNumber: JSON.parse(localStorage.getItem("organization"))
            .twilio_integration?.M.primary_phone.S,
          forwarding_number: forward_number,
          code: await encryptApi(code),
          account_sid: JSON.parse(localStorage.getItem("organization"))
            .twilio_integration.M.account_sid.S,
          api_key: (JSON.parse(localStorage.getItem("organization")).twilio_integration
            .M.api_key.S),
        }
      );
      console.log(response);
      setCodeSent(true);
      setTimeLeft(60)

      setLoader(false);
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        console.error("Response data:", error.response.data);
        setErrormsg(error.response.data.error);
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
      setLoader(false);
    }
  }

  //recording
  const [recording, setRecording] = useState(null);

  //create channel and route
  const completeOnboardingforFowardedCall = async () => {
    setErrormsg(null);
    if (forward_action === 1) {
      try {
        setLoader(true);
        let channel = await axios.post(
          process.env.REACT_APP_BACKEND_URL + "add-channel",
          {
            label: "Forwarding Number 1",
            last_updated: String(Math.floor(Date.now() / 1000)),
            status: "active",
            type: "forward_number",
            value: String(forward_number),
            organization_id: JSON.parse(localStorage.getItem("organization"))
              .orgId.S,
            slack_id: "",
            api_key: "",
            front_id: "",
          }
        );

        console.log(channel);
          let channel_data = await axios.post(
                                       process.env.REACT_APP_BACKEND_URL + "add-channel",
                                       {
                                        label: "my email",
                                        last_updated: String(Math.floor(Date.now() / 1000)),
                                        status:"active",
                                        type:  "email",
                                        value: user.email,
                                        organization_id: JSON.parse(localStorage.getItem("organization")).orgId.S,
                                        slack_id: "",
                                        api_key: "",
                                        front_id: "",
                                      }

                                     );


        let route = await axios.post(
          process.env.REACT_APP_BACKEND_URL + "route/create-route",
          {
            route_name: "Route 1",
            configured_phone: JSON.parse(localStorage.getItem("organization"))
              .twilio_integration.M.primary_phone.S,
            organization_id: JSON.parse(localStorage.getItem("organization"))
              .orgId.S,
            early_time: "12:00 AM",
            late_time: "11:59 PM",
            primary_action: forward_action === 1 ? "forward" : "play_recording",
            recording_id: "",
            primary_number: String(forward_number),
            primary_channel: channel_data.data.channel_id,
            off_hours_action: "",
            off_hours_recording: "",
            off_hours_number: "",
            off_hours_channel: "",
            active_friday: true,
            active_monday: true,
            active_saturday: true,
            active_sunday: true,
            active_thursday: true,
            active_tuesday: true,
            active_wednesday: true,
          }
        );

        let organization = await axios.post(
          process.env.REACT_APP_BACKEND_URL + "add-route",
          {
            organization_id: JSON.parse(localStorage.getItem("organization"))
              .orgId.S,
            route_id: route.data.route.routeId.S,
          }
        );

        localStorage.setItem(
          "organization",
          JSON.stringify(organization.data.organization)
        );


        let t = JSON.parse(localStorage.getItem("organization")).twilio_integration
          .M;

        if (t.auto_configuration.BOOL) {
          let update_voice = await axios.post(
            process.env.REACT_APP_BACKEND_URL + "twilio/update-voice-url",
            {
              account_sid: t.account_sid.S,
              api_key: t.api_key.S,
              phone_number: t.primary_phone.S,
              webhook_url: `https://incoming.twilanswer.com/${route.data.route.routeId.S}`
            }
          );

          console.log({ update_voice })
        }
        setLoader(false);
        console.log({ channel }, { route }, { organization });
        navigate("/dashboard/call-route/" + route.data.route.routeId.S);
        localStorage.setItem('show_confetti', true)
      } catch (error) {
        setLoader(false);
        setErrormsg(error.message);
        console.log(error);
      }
    } else {
      try {
        setLoader(true);

        //upload recording
        console.log(uploadedFile);
        const formData = new FormData();
        if (audioBlob) {
          console.log(audioBlob)
          formData.append("file", audioBlob, `${recording_data.title}-${Date.now()}.${audioBlob.type.split('/')[1]}`);
        } else {
          formData.append("file", uploadedFile, `${recording_data.title}-${Date.now()}.${uploadedFile.name.split('.').pop().toLowerCase()}`);
        }


        const recording = await axios.post(
          process.env.REACT_APP_BACKEND_URL + "upload",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        console.log()

        let record = await axios.post(
          process.env.REACT_APP_BACKEND_URL + "add-recording",
          {
            title: recording_data.title,
            type: record_type,
            url: recording.data.url,
            organization_id: JSON.parse(localStorage.getItem("organization"))
              .orgId.S,
          }
        );





        console.log("recording", recording);


        let channel_data = await axios.post(
          process.env.REACT_APP_BACKEND_URL + "add-channel",
          {
           label: "my email",
           last_updated: String(Math.floor(Date.now() / 1000)),
           status:"active",
           type:  "email",
           value: user.email,
           organization_id: JSON.parse(localStorage.getItem("organization")).orgId.S,
           slack_id: "",
           api_key: "",
           front_id: "",
         }

        );

        let route = await axios.post(
          process.env.REACT_APP_BACKEND_URL + "route/create-route",
          {
            route_name: "Route 1",
            configured_phone: JSON.parse(localStorage.getItem("organization"))
              .twilio_integration.M.primary_phone.S,
            organization_id: JSON.parse(localStorage.getItem("organization"))
              .orgId.S,
            early_time: "12:00 AM",
            late_time: "11:59 PM",
            primary_action: forward_action === 1 ? "forward" : "play_recording",
            recording_id: record.data.rec_id,
            primary_number: "",
            primary_channel: channel_data.data.channel_id,
            off_hours_action: "",
            off_hours_recording: "",
            off_hours_number: "",
            off_hours_channel: "",
            active_friday: true,
            active_monday: true,
            active_saturday: true,
            active_sunday: true,
            active_thursday: true,
            active_tuesday: true,
            active_wednesday: true,
          }
        );

        let t = JSON.parse(localStorage.getItem("organization")).twilio_integration
          .M;

        if (t.auto_configuration.BOOL) {
          let update_voice = await axios.post(
            process.env.REACT_APP_BACKEND_URL + "twilio/update-voice-url",
            {
              account_sid: t.account_sid.S,
              api_key: t.api_key.S,
              phone_number: t.primary_phone.S,
              webhook_url: `https://incoming.twilanswer.com/${route.data.route.routeId.S}`
            }
          );

          console.log({ update_voice })
        }

        let organization = await axios.post(
          process.env.REACT_APP_BACKEND_URL + "add-route",
          {
            organization_id: JSON.parse(localStorage.getItem("organization"))
              .orgId.S,
            route_id: route.data.route.routeId.S,
          }
        );

        localStorage.setItem(
          "organization",
          JSON.stringify(organization.data.organization)
        );

        setLoader(false);
        console.log({ record }, { route }, { organization });
        setRecordings(organization.data.organization.recordings.L);
        restartRecording()
        setRecordingData({ title: '' })
        setLoader(false);
        setErrorMsg(null)
        navigate("/dashboard/call-route/" + route.data.route.routeId.S);
        localStorage.setItem('show_confetti', true)
      } catch (error) {
        setLoader(false);
        setErrormsg(error.message);
        console.log(error);
      }
    }
  };

  const [loader1, setLoader1] = useState(false);
  async function getIncomingPhoneNumbers() {
    setLoader1(true);
    setErrormsg(null);
    try {
      await axios
        .post(
          process.env.REACT_APP_BACKEND_URL +
          "twilio/get-incoming-phone-numbers",
          {...twilio_information, api_key: await encryptApi(twilio_information.api_key)}
        )
        .then((res) => {
          if (res.data.length < 1) {
            setErrormsg(
              "Please add an incoming phone number in your twilio account"
            );
            setLoader1(false);

          } else {
            setIncommingPhonenumbers(res.data);
            console.log(res.data);
            setLoader1(false);
          }
        })
        .catch((err) => {
          console.log(err);
          setErrormsg("wrong account_sid or api key");
          setLoader1(false);
          setIncommingPhonenumbers([]);
          setTwilioInformation({ ...twilio_information, primary_phone: '' })
        });
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        console.error("Response data:", error.response.data);
        setErrormsg(error.response.data.message);
      }
      setLoader(false);
    }
  }

  function generateVerificationCode() {
    return Math.floor(100000 + Math.random() * 900000); // Generates a random 6-digit number
  }

  useEffect(() => {
    setErrorMsg(null)
    setVerificationCode(generateVerificationCode());
  }, []);





  //recording mods
  const [record_type, setRecordType] = useState("upload_mp3");
  const [uploadedFile, setUploadedFile] = useState(null);

  const [buttonState, setButtonState] = useState("record"); // "record", "stop", "play"
  const [time, setTime] = useState(0); // Timer in seconds
  const [maxTime, setMaxTime] = useState(30); // Timer in seconds
  const [audioBlob, setAudioBlob] = useState(null); // Stores the recorded audio
  const [isRecording, setIsRecording] = useState(false); // Tracks recording state
  const mediaRecorderRef = useRef(null); // MediaRecorder reference
  const audioUrlRef = useRef(null); // URL for the audio playback
  const mediaStreamRef = useRef(null); // Stores the media stream
  const [recording_data, setRecordingData] = useState({
    title: "",
    type: "",
  });

  // Handle button click to toggle states and recording
  const handleClick = () => {
    if (buttonState === "record") {
      startRecording();
      setButtonState("stop");
    } else if (buttonState === "stop") {
      stopRecording();
      setButtonState("play");
    } else if (buttonState === "play") {
      playRecording();
      setButtonState('playing')
    } else if (buttonState === "playing") {
      stopPlaying();
      setButtonState("play");
    }
  };

  // Start recording
  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaStreamRef.current = stream;
  
      // Create an AudioContext for processing audio
      const audioContext = new AudioContext({ sampleRate: 8000 }); // Set sample rate to 8000 Hz
      const mediaStreamSource = audioContext.createMediaStreamSource(stream);
  
      // Create a MediaRecorder
      const mediaRecorder = new MediaRecorder(stream);
      mediaRecorderRef.current = mediaRecorder;
  
      const chunks = [];
      mediaRecorder.ondataavailable = (event) => chunks.push(event.data);
  
      mediaRecorder.onstop = async () => {
        // Combine chunks into a single Blob
        const rawAudioBlob = new Blob(chunks, { type: "audio/webm" });
  
        // Decode the audio data and resample it
        const arrayBuffer = await rawAudioBlob.arrayBuffer();
        const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
  
        // Resample and export the audio
        const processedAudioBlob = await resampleAndExport(audioBuffer, audioContext);
  
        // Save the processed audio
        setAudioBlob(processedAudioBlob);
        audioUrlRef.current = URL.createObjectURL(processedAudioBlob);
        setIsRecording(false);
      };
  
      mediaRecorder.onstart = () => {
        setIsRecording(true);
        setTimeout(() => {
          if (mediaRecorder.state === "recording") {
            mediaRecorder.stop();
            stopRecording();
          }
        }, 30000);
      };
  
      mediaRecorder.start();
    } catch (error) {
      console.error("Error accessing microphone:", error);
    }
  };
  
  const resampleAndExport = async (audioBuffer, audioContext) => {
    const offlineAudioContext = new OfflineAudioContext(
      1, // Mono audio
      audioBuffer.length,
      8000 // Target sample rate
    );
  
    const bufferSource = offlineAudioContext.createBufferSource();
    bufferSource.buffer = audioBuffer;
    bufferSource.connect(offlineAudioContext.destination);
    bufferSource.start(0);
  
    const resampledBuffer = await offlineAudioContext.startRendering();
  
    // Export the resampled audio as a WAV Blob
    return audioBufferToWav(resampledBuffer);
  };
  
  const audioBufferToWav = (buffer) => {
    const numChannels = buffer.numberOfChannels;
    const sampleRate = buffer.sampleRate;
    const length = buffer.length * numChannels;
    const wavBuffer = new ArrayBuffer(44 + length * 2);
    const view = new DataView(wavBuffer);
  
    // Write WAV header
    const writeString = (offset, string) => {
      for (let i = 0; i < string.length; i++) {
        view.setUint8(offset + i, string.charCodeAt(i));
      }
    };
  
    writeString(0, "RIFF");
    view.setUint32(4, 36 + length * 2, true);
    writeString(8, "WAVE");
    writeString(12, "fmt ");
    view.setUint32(16, 16, true);
    view.setUint16(20, 1, true); // PCM format
    view.setUint16(22, numChannels, true);
    view.setUint32(24, sampleRate, true);
    view.setUint32(28, sampleRate * 2, true);
    view.setUint16(32, numChannels * 2, true);
    view.setUint16(34, 16, true); // Bits per sample
    writeString(36, "data");
    view.setUint32(40, length * 2, true);
  
    // Write audio data
    const channelData = buffer.getChannelData(0);
    let offset = 44;
    for (let i = 0; i < channelData.length; i++) {
      view.setInt16(offset, channelData[i] * 0x7fff, true);
      offset += 2;
    }
  
    return new Blob([view], { type: "audio/wav" });
  };


  // Stop recording and turn off the microphone
  const stopRecording = () => {
    setIsRecording(false); // Stop the timer
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
    }
    // Stop the microphone stream
    if (mediaStreamRef.current) {
      mediaStreamRef.current.getTracks().forEach((track) => track.stop()); // Stop all tracks (including audio)
    }
  };


  const audioRef = useRef(null);
  const intervalIdRef = useRef(null);

  const [currentTime, setCurrentTime] = useState(0);

  const playRecording = () => {
    if (audioUrlRef.current) {
      if (!audioRef.current) {
        // Create a new audio instance if not already created
        audioRef.current = new Audio(audioUrlRef.current);

        // Set the max time to the length of the audio (in seconds)
        setMaxTime(30);
      }

      audioRef.current.currentTime = 0; // Start from the beginning of the audio
      audioRef.current.play();

      // Clear any previous interval and start a new timer
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
      }

      intervalIdRef.current = setInterval(() => {
        // Update current time based on audio playback
        setCurrentTime(audioRef.current.currentTime);
        if (audioRef.current.currentTime >= maxTime) {
          clearInterval(intervalIdRef.current); // Stop the timer once the audio finishes
          intervalIdRef.current = null;
        }


      }, 1000); // Update every second to match audio playback


      audioRef.current.onended = () => {
        // Update the button state to "playing"
        setButtonState("play"); // Make sure you have this state defined
        stopPlaying(); // Stop the audio and the timer
      };
    }
  };

  const stopPlaying = () => {
    if (audioRef.current) {
      audioRef.current.pause(); // Pause the audio
    }
    if (intervalIdRef.current) {
      clearInterval(intervalIdRef.current); // Stop the timer
      intervalIdRef.current = null;
    }
  };


  // Restart recording (reset state and start over)
  const restartRecording = () => {
    stopRecording(); // First stop any ongoing recording
    setTime(0); // Reset the timer
    setAudioBlob(null); // Clear the previous audio
    setButtonState("record"); // Reset to "record" button
    setMaxTime(30);
    mediaStreamRef.current = null
    audioRef.current = null
    audioUrlRef.current = null
    mediaRecorderRef.current = null
    intervalIdRef.current = null
  };




  // Timer logic for recording
  useEffect(() => {
    let timerInterval;
    let t = 0;
    if (isRecording) {
      timerInterval = setInterval(() => {
        if (t < maxTime) {
          t += 1;
          setTime((prev) => prev + 1);
        } else {
          stopRecording();
        }
      }, 1000);
    } else {
      clearInterval(timerInterval);
    }
    return () => clearInterval(timerInterval);
  }, [isRecording]);

  // Format time as mm:ss
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? `0${secs}` : secs}`;
  };
  const [err_msg, setErrorMsg] = useState(null);
  const [loader, setLoader] = useState(false);

  //recordings

  const [recordings, setRecordings] = useState(
    JSON.parse(localStorage.getItem("organization"))?.recordings?.L || []
  );



  function decodeToken(token) {
    console.log(token)
    try {
      const decoded = jwtDecode(token);
      console.log({ decoded })
      return decoded.api_key;
    } catch (error) {
      console.error('Invalid token:', error);
      return null;
    }
  }


  //change the primary phone state whenevver account sid or auth token changes
  useEffect(() => {
    if (twilio_information.account_sid.length >= 34 && twilio_information.api_key.length >= 34) {
      getIncomingPhoneNumbers()
    }
  }, [twilio_information.account_sid, twilio_information.api_key])

  //check if user has twilio_information and exist
  useEffect(() => {
    setErrormsg(null)
    let organization = JSON.parse(localStorage.getItem("organization"));
    console.log(organization)
    if (organization && !organization.twilio_integration) {
      setStep(2);
    }
    if (organization && organization.twilio_integration && !organization.routes) {
      setStep(4)
    }
    if (organization && organization.twilio_integration && organization.routes) {
      navigate('/dashboard/call-routings');
    }


  }, []);

  useEffect(() => {
    if (errorMsg) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [errorMsg])


  const [loadState, setLoadState] = useState(true)


  useEffect(() => {

    setTimeout(() => {
      setLoadState(false)
    }, 2000);

  }, []); // Runs only once when the component mounts

  return (
    <div>
      {/* {loadState && (
         <div
         style={{
           position: "fixed",
           top: 0,
           left: 0,
           width: "100vw",
           height: "100vh",
           backdropFilter: "blur(10px)",
           backgroundColor: "rgba(0, 0, 0, 0.5)",
           display: "flex",
           justifyContent: "center",
           alignItems: "center",
           zIndex: 9999,
         }}
       >
         <Box>
           <div className="flex items-center text-white text-[15px]">
           <div style={{ display: "flex", gap: "0.5rem", marginRight: '5px' }}>
           <span className="dot"></span>
           <span className="dot"></span>
           <span className="dot"></span>
         </div>
         <style jsx>{`
           .dot {
             width: 12px;
             height: 12px;
             background-color: #fff;
             border-radius: 50%;
             animation: bounce 1.5s infinite;
           }
           .dot:nth-child(2) {
             animation-delay: 0.2s;
           }
           .dot:nth-child(3) {
             animation-delay: 0.4s;
           }
           @keyframes bounce {
             0%, 80%, 100% {
               transform: scale(0);
             }
             40% {
               transform: scale(1);
             }
           }
         `}</style>
              Twilanswer loading </div>
         </Box>
       </div>
      )} */}
      <div className="grid lg:grid-cols-4">
        <div className="col-span-1 lg:pt-[10px] pt-[20px] bg-white lg:min-h-[100vh] min-h-[100vh] relative px-8  lg:my-0">
          <div className="flex items-center justify-center">
            <img src="/icons/login_img.png" className="w-[50px]" />
          </div>
          <div className="text-center lg:text-[16px] mt-4  font-semibold ">
            Sign Up
          </div>

          {errorMsg && (
            <div className="text-center text-red-500 lg:text-[13px] text-[12px] mt-2  font-semibold ">
              <ErrorOutline sx={{ fontSize: "" }} /> {errorMsg}
            </div>
          )}

          {step === 1 && (
            <div>
              <div className="flex items-center justify-center py-2 rounded-[4px] mt-4">
                <SigninWithGoogle page='register' user={user}
                  setErrormsg={setErrormsg} setStep={setStep} step={step}
                  loader={loader} setLoader={setLoader} setUser={setUser} />
              </div>

              <div className="flex items-center justify-center space-x-1 mb-4 mt-1  ">
                <Divider className="w-[100px]" />
                <div className="relative bottom-[2px]">or</div>
                <Divider className="w-[100px]" />
              </div>

              <div className="flex items-center space-x-4">
                <div className="space-y-2 mb-3">
                  <div className=" lg:text-[14px] text-[13px] ">First Name</div>
                  <InputBase
                    value={user.first_name}
                    disabled={user.registeredFromGoogle}
                    onChange={(e) => {
                      setUser({ ...user, first_name: e.target.value });
                    }}
                    placeholder="e.g John"
                    sx={{
                      bgcolor: "#F7F7F8",
                      width: "100%",
                      px: 2,
                      py: "2px",
                      fontSize: "14px",
                    }}
                  />
                </div>
                <div className="space-y-2 mb-3">
                  <div className=" lg:text-[14px] text-[13px] ">Last Name</div>
                  <InputBase
                    value={user.last_name}
                    disabled={user.registeredFromGoogle}
                    onChange={(e) => {
                      setUser({ ...user, last_name: e.target.value });
                    }}
                    placeholder="e.g Micheal"
                    sx={{
                      bgcolor: "#F7F7F8",
                      width: "100%",
                      px: 2,
                      py: "2px",
                      fontSize: "14px",
                    }}
                  />
                </div>
              </div>

              <div className="space-y-2 mb-3">
                <div className=" lg:text-[14px] text-[13px] ">
                  Email Address
                </div>
                <InputBase
                  value={user.email}
                  disabled={user.registeredFromGoogle}
                  onChange={(e) => {
                    setUser({ ...user, email: e.target.value });
                  }}
                  placeholder="johnmichael@example.com"
                  sx={{
                    bgcolor: "#F7F7F8",
                    width: "100%",
                    px: 2,
                    py: "2px",
                    fontSize: "14px",
                  }}
                />
              </div>

              <div className="space-y-2 mb-3">
                <div className=" lg:text-[14px] text-[13px] ">Company Name</div>
                <InputBase
                  id='123'
                  value={user.company_name}
                  onChange={(e) => {
                    setUser({ ...user, company_name: e.target.value });
                  }}
                  placeholder="ACME Inc."
                  sx={{
                    bgcolor: "#F7F7F8",
                    width: "100%",
                    px: 2,
                    py: "2px",
                    fontSize: "14px",
                  }}
                />
              </div>

              <div hidden={user.registeredFromGoogle} className="space-y-2">
                <div className=" lg:text-[14px] text-[13px] ">Password</div>
                <InputBase
                  // type={showPassword ? "text" : "password"}
                  type={'password'}
                  value={user.password}
                  onChange={(e) => {
                    setUser({ ...user, password: e.target.value });
                  }}
                  // endAdornment={
                  //   <InputAdornment
                  //     position="end"
                  //     onClick={handleTogglePassword}
                  //     className="cursor-pointer"
                  //   >
                  //     {showPassword ? <VisibilityOff /> : <Visibility />}
                  //   </InputAdornment>
                  // }
                  sx={{
                    bgcolor: "#F7F7F8",
                    width: "100%",
                    px: 2,
                    py: "2px",
                    fontSize: "14px",
                  }}
                />
              </div>

              <div className="flex items-center space-x-3  mt-2">
                <div className="flex items-center">
                  <Checkbox
                    defaultChecked={false}
                    defaultValue={false}
                    value={user.agreed || false}
                    onChange={(e) => {
                      setUser({...user, agreed:e.target.value})
                    }}
                    size="lg"
                    sx={{
                      color: "#605BFF",
                      "&.Mui-checked": {
                        color: "#605BFF", // Set color for checked state
                      },
                    }}
                  />
                  <div className="text-[13px]">
                    By creating an account you agree to the
                    <span className="text-[#605BFF] hover:underline cursor-pointer "
                      onClick={() => window.open('https://twilanswer.com/terms-and-conditions/', '_blank')}
                    >
                      {" "}
                      terms of use{" "}
                    </span>
                    and our
                    <span
                      onClick={() => window.open('https://twilanswer.com/privacy', '_blank')}
                      className="text-[#605BFF] hover:underline cursor-pointer ">
                      {" "}
                      privacy policy
                    </span>
                    .
                  </div>
                </div>
              </div>

              <div className="flex justify-center pt-6 pb-4 space-x-2">
                <Button
                  sx={{
                    textTransform: "none",
                    bgcolor: "#605BFF",
                    color: "white",
                    py: "6px",
                    px: "40px",
                    borderRadius: "7px",
                    fontSize: { lg: "14px", xs: "13px" },
                    width: "100%",
                  }}
                  disabled={loader}
                  onClick={registerUser}
                >
                  {loader ? (
                    <CircularProgress size={"1.3rem"} sx={{ color: "white" }} />
                  ) : (
                    "Register"
                  )}
                </Button>
              </div>

              <div className="text-black text-center lg:text-[13px] text-[12px] ">
                Already have an account?{" "}
                <span
                  className="text-[#605BFF] hover:underline cursor-pointer "
                  onClick={() => navigate("/login")}
                >
                  {" "}
                  Log in
                </span>
              </div>
            </div>
          )}

          {step === 2 && (
            <div className=" mt-[150px] ">
              <div className="text-[14px] text-center">
                Do you have a Twilio Account already?
              </div>

              <div className="flex justify-center pt-6 pb-4 space-x-2">
                <Button
                  sx={{
                    textTransform: "none",
                    bgcolor: "#605BFF",
                    color: "white",
                    py: "6px",
                    px: "40px",
                    borderRadius: "7px",
                    fontSize: { lg: "14px", xs: "13px" },
                    width: "100%",
                  }}
                  onClick={() => setStep(step + 1)}
                >
                  Yes
                </Button>

                <Button
                  sx={{
                    textTransform: "none",
                    bgcolor: "white",
                    color: "#605BFF",
                    py: "6px",
                    px: "40px",
                    borderRadius: "7px",
                    fontSize: { lg: "14px", xs: "13px" },
                    border: "1px solid #605BFF",
                    width: "100%",
                  }}
                  onClick={() => setOpenRequireModal(true)}
                >
                  No
                </Button>
                <RequireTwilioAccountModal
                  open={openRequireModal}
                  setOpen={setOpenRequireModal}
                  step={step}
                  setStep={setStep}
                />
              </div>


            </div>
          )}

          {step === 3 && (
            <div className="lg:mt-[70px] mt-[20px]">
              <div className="lg:hidden">
                <div className="text-center lg:text-[18px] text-[15px] font-[500] mb-3">
                  How to Configure Twilio
                </div>
                <iframe
                  width="100%"
                  height="200"
                  src="https://www.youtube.com/embed/f3LKG7kBq74?si=o_QpCRkdK9mfenlx"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>

                <div className="text-black text-center lg:text-[13px]   text-[12px] ">
                  More info on our{" "}
                  <span className="text-[#605BFF] cursor-pointer hover:underline  "
                  onClick={()=> {
                    window.open('https://twilanswer.com/docs/how-to-integrate-twilio-with-twilanswer/', '_blank')
                  }}
                  >
                    help page
                  </span>
                </div>
              </div>
              <div className="text-center lg:text-[16px] text-[14px] font-[500] mb-3">
                Let’s get your Twilio connection info
              </div>

              <div className="space-y-1 mb-3">
                <div className=" lg:text-[14px] text-[13px] ">Account SID</div>
                <InputBase
                  value={twilio_information.account_sid}
                  name='account sid'
                  inputProps={{
                    maxLength: 34, // Restrict maximum input length to 34
                    minLength: 34, // Enforce minimum input length for validation
                  }}
                  onChange={(e) => {
                    setTwilioInformation({
                      ...twilio_information,
                      account_sid: e.target.value,
                    });
                  }}
                  sx={{
                    bgcolor: "#F7F7F8",
                    width: "100%",
                    px: 2,
                    py: "2px",
                    fontSize: "14px",
                  }}
                />
              </div>

              <div className="space-y-1 mb-3">
                <div className=" lg:text-[14px] text-[13px] ">Auth Token</div>

                <InputBase
                  type={showPassword ? "text" : "password"}
                  name='auth token'
                  inputProps={{
                    maxLength: 34, // Restrict maximum input length to 34
                    minLength: 34, // Enforce minimum input length for validation
                  }}
                  value={twilio_information.api_key}
                  onChange={(e) => {
                    setTwilioInformation({
                      ...twilio_information,
                      api_key: e.target.value,
                    });
                  }}
                  endAdornment={
                    <InputAdornment
                      position="end"
                      onClick={handleTogglePassword}
                      className="cursor-pointer"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </InputAdornment>
                  }
                  sx={{
                    bgcolor: "#F7F7F8",
                    width: "100%",
                    px: 2,
                    py: "2px",
                    fontSize: "14px",
                  }}
                />
              </div>

              <div className="space-y-1 mb-3">
                <div className="flex justify-between items-center">
                  <div className=" lg:text-[14px] text-[13px] ">
                    Primary Phone Number
                  </div>
                  <div className=" space-x-2">
                    <Button
                      sx={{
                        textTransform: "none",
                        bgcolor: "#605BFF",
                        color: "white",
                        py: "1px",
                        px: { lg: "6px", xs: "10px" },
                        borderRadius: "7px",
                        fontSize: { lg: "13px", xs: "13px" },
                        width: "fit",
                      }}
                      onClick={getIncomingPhoneNumbers}
                    >
                      {loader1 ? (
                        <CircularProgress
                          size={"1rem"}
                          sx={{ color: "white" }}
                        />
                      ) : (
                        " Load Numbers"
                      )}
                    </Button>
                  </div>
                </div>

                <div className="text-[11px] my-1">
                  The main phone number you’d like to setup call forwarding for.
                  You can change this later in settings.
                </div>
                <div className="lg:w-full w-[82vw]">
                  <Select
                    IconComponent={KeyboardArrowDown}
                    fullWidth
                    className="mb-2 bg-[#F7F7F8]"
                    value={twilio_information.primary_phone}
                    onChange={(e) => {
                      setTwilioInformation({
                        ...twilio_information,
                        primary_phone: e.target.value,
                      });
                    }}
                    sx={{
                      fontSize: "14px",
                      padding: "4px 8px", // Adjust padding here
                      "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                      "& .MuiSelect-select": {
                        padding: "4px 8px", // Adjust padding for the text inside Select
                      },
                    }}
                  >
                    <MenuItem value="select">Select a phone number</MenuItem>
                    {incomming_phonenumbers &&
                      incomming_phonenumbers.map((item, index) => (
                        <MenuItem value={item.phoneNumber}>
                          {formatPhoneNumber(item.phoneNumber)}
                        </MenuItem>
                      ))}
                  </Select>
                </div>
              </div>

              <div className="space-y-2 mb-3">
                <div className=" lg:text-[14px] text-[13px] ">
                  Autoconfiguration
                </div>

                <div className="text-[11px] my-2">
                  Would you like us to update the incoming call settings to
                  point to Twilanswer automatically, or would you like to do
                  that manually later?
                </div>
                <div className="lg:w-full w-[82vw]">
                  <Select
                    IconComponent={KeyboardArrowDown}
                    fullWidth
                    defaultValue={true}
                    value={twilio_information.auto_configuration}
                    onChange={(e) => {
                      setTwilioInformation({
                        ...twilio_information,
                        auto_configuration: e.target.value,
                      });
                    }}
                    className="mb-2 bg-[#F7F7F8]"
                    sx={{
                      fontSize: "14px",
                      padding: "4px 8px", // Adjust padding here
                      "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                      "& .MuiSelect-select": {
                        padding: "4px 8px", // Adjust padding for the text inside Select
                      },
                    }}
                  >
                    <MenuItem value={true}>
                      Yes, automatically configure the settings in Twilio
                    </MenuItem>
                    <MenuItem value={false}>
                      No, do not automatically configure the settings in Twilio
                    </MenuItem>
                  </Select>
                </div>
              </div>

              <div className="flex justify-center pt-4 pb-4 space-x-2">
                <Button
                  sx={{
                    textTransform: "none",
                    bgcolor: "#605BFF",
                    color: "white",
                    py: "6px",
                    px: "30px",
                    borderRadius: "7px",
                    fontSize: { lg: "14px", xs: "13px" },
                    width: "fit",
                  }}
                  disabled={loader}
                  onClick={() => {
                    addTwilioInformation()
                    setErrorMsg(null)
                    setErrormsg(null)
                  }}
                >
                  {loader ? (
                    <CircularProgress size={"1.3rem"} sx={{ color: "white" }} />
                  ) : (
                    " Next"
                  )}
                </Button>
              </div>

              {/* <div className="text-[#605BFF] text-center lg:text-[13px] lg:absolute  bottom-4 cursor-pointer hover:underline lg:left-[34%] left-[35%]   text-[12px] ">
                Skip Guided Setup
              </div> */}
            </div>
          )}

          {step === 4 && (
            <div className="mt-[50px]">
              <div className="lg:hidden">
                <div className="text-center lg:text-[18px] text-[15px] font-[500] mb-3">
                  Forward Action Option
                </div>
                <iframe
                  width="100%"
                  height="200"
                  src="https://www.youtube.com/embed/Hn1-di--OCI?si=QKqwFXLiHLRHqEcB"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>

                <div className="text-black text-center lg:text-[13px]   text-[12px] ">
                  More info on our{" "}
                  <span className="text-[#605BFF] cursor-pointer hover:underline  "
                   onClick={()=> {
                    window.open('https://twilanswer.com/docs/how-to-create-a-twilanswer-account/', '_blank')
                  }}
                  >
                    help page
                  </span>
                </div>
              </div>
              <div className="text-center lg:text-[16px] text-[14px] font-[500] mb-3">
                Setup your forward action
              </div>

              <div className="flex justify-center pt-6 pb-4 space-x-5">
                <div
                  className={
                    forward_action === 1
                      ? "flex items-center border-[1px] border-[#605BFF] text-[#605BFF] text-[15px] py-1 px-3 rounded-[10px] cursor-pointer"
                      : "flex items-center border-[1px] border-[#9A9AA9] text-[#9A9AA9] text-[15px] py-1 px-3 rounded-[10px] cursor-pointer"
                  }
                  onClick={() => setSelectedForwardAction(1)}
                >
                  <PhoneForwarded
                    sx={
                      forward_action === 1
                        ? { color: "#605BFF", fontSize: "25px" }
                        : { color: "#9A9AA9", fontSize: "25px" }
                    }
                  />
                  <div className="text-center"> Forwarded Call </div>
                </div>

                <div
                  className={
                    forward_action === 2
                      ? "flex items-center border-[1px] border-[#605BFF] text-[#605BFF] text-[15px] py-1 px-3 rounded-[10px] cursor-pointer"
                      : "flex items-center border-[1px] border-[#9A9AA9] text-[#9A9AA9] text-[15px] py-1 px-3 rounded-[10px] cursor-pointer"
                  }
                  onClick={() => setSelectedForwardAction(2)}
                >
                  <PlayCircleFilledOutlined
                    sx={
                      forward_action === 2
                        ? { color: "#605BFF", fontSize: "25px" }
                        : { color: "#9A9AA9", fontSize: "25px" }
                    }
                  />
                  <div className="text-center"> Play Recording </div>
                </div>
              </div>

              {forward_action === 1 && (
                <div className="mb-20">
                  <div className="text-[13px] text-[#030229] text-center mb-5">
                    Forward incoming calls to another phone number.
                  </div>

                  <div className="space-y-1 mb-7">
                    <div className=" lg:text-[14px] text-[13px] ">
                      Forward Number
                    </div>
                    <div className="flex items-center space-x-2">
                      <InputBase
                        value={forward_number}
                        onChange={(e) => {
                          setForwardNumber(e.target.value);
                        }}
                        sx={{
                          bgcolor: "#F7F7F8",
                          width: "100%",
                          px: 2,
                          py: "2px",
                          fontSize: "14px",
                        }}
                      />
                      {timeLeft >= 1 ? (
                        <Button
                          sx={{
                            textTransform: "none",
                            bgcolor: "#605BFF",
                            color: "white",
                            py: "1px",
                            px: "10px",
                            borderRadius: "7px",
                            fontSize: { lg: "13px", xs: "12px" },
                          }}
                        >
                          Expires({timeLeft})
                        </Button>
                      ) : (
                        <Button
                          sx={{
                            textTransform: "none",
                            bgcolor: "#605BFF",
                            color: "white",
                            py: "4px",
                            px: "10px",
                            borderRadius: "7px",
                            fontSize: { lg: "14px", xs: "13px" },
                            width: "fit",
                          }}
                          onClick={sendPhoneVerificationText}
                        >
                          {loader ? (
                            <CircularProgress
                              size={"1.3rem"}
                              sx={{ color: "white" }}
                            />
                          ) : (
                            " Verify"
                          )}
                        </Button>
                      )}

                    </div>
                  </div>

                  <div className="space-y-1 mb-3 mt-3" hidden={!codeSent} >
                    <div className=" lg:text-[14px] text-[13px] ">
                      Verification Code
                    </div>

                    <InputBase
                      value={verificationCodeConfirmation}
                      onChange={(e) => {
                        setVerificationCodeConfirmation(e.target.value);
                      }}
                      sx={{
                        bgcolor: "#F7F7F8",
                        width: "75%",
                        px: 2,
                        py: "2px",
                        fontSize: "14px",
                      }}
                    />
                  </div>
                </div>
              )}

              {forward_action === 2 && (
                <div className="mb-12">
                  <div className="text-[13px] text-[#030229] text-center mb-5">
                    Play an audio recording when people call.
                  </div>

                  <div className="space-y-2">
                    <div className="">
                      <Select
                        IconComponent={KeyboardArrowDown}
                        fullWidth
                        value={record_type}
                        onChange={(e) => setRecordType(e.target.value)}
                        className="mb-2 bg-[#F7F7F8]"
                        sx={{
                          fontSize: "13px",
                          padding: "2px 8px", // Adjust padding here
                          "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                          "& .MuiSelect-select": {
                            padding: "2px 8px", // Adjust padding for the text inside Select
                          },
                        }}
                      >
                        <MenuItem value="upload_mp3">Upload MP3</MenuItem>
                        <MenuItem value="record_now">Record Now</MenuItem>
                      </Select>
                    </div>

                    <div className=" items-center w-full">
                      <div className="lg:flex-1 ">
                        {record_type === "upload_mp3" && (
                          <div className=" flex items-center space-x-4  mb-2 ">
                            <input
                              hidden
                              type="file"
                              id="upload_record"
                              accept=".mp3, .m4a, .wav"
                              onChange={(e) => {
                                const file = e.target.files[0];

                                const maxSize = 25 * 1024 * 1024; // 5 MB in bytes

                                if (file) {
                                  // Check file size
                                  if (file.size > maxSize) {
                                    alert(
                                      "Uploaded file too large. Please upload a file less than 25MB"
                                    );
                                    e.target.value = ""; // Clear the file input
                                    setUploadedFile(null);
                                  } else {
                                    const fileExtension = file.name.split('.').pop().toLowerCase();
                                    const allowedExtensions = ['mp3', 'm4a', 'wav'];
                                    if (!allowedExtensions.includes(fileExtension)) {
                                      alert('Unsupported file type detected. Please upload mp3, m4a, or wav.');
                                      e.target.value = ''; // Clear the file input
                                    } else {
                                      setUploadedFile(file); // Set the uploaded file if valid
                                    }

                                  }
                                }
                              }}
                            />
                            <img
                              src="/icons/upload.png"
                              className="lg:w-[50px] w-[30px] "
                              onClick={() => {
                                document.getElementById("upload_record").click();
                              }}
                            />

                            <div className="lg:text-[14px] text-[13px] italic ">
                              {" "}
                              {uploadedFile ? uploadedFile.name : "No file uploaded"}{" "}
                            </div>
                          </div>
                        )}

                        {record_type === "record_now" && (
                          <div className="flex items-center space-x-1 mb-2 lg:mb-2">
                            <div className=" audio-input-ui " style={{ width: '100%' }}>
                              <button
                                className={`record-button ${buttonState}`}
                                onClick={handleClick}
                              ></button>
                              <span className="audio-timer">
                                {formatTime(time)}/{formatTime(maxTime)}
                              </span>
                            </div>

                            {buttonState === "play" && (
                              <DeleteOutline
                                className="lg:w-[17px] w-[15px] cursor-pointer"
                                onClick={() => {
                                  restartRecording();
                                }}
                              />
                            )}
                          </div>
                        )}
                      </div>

                      <div className="lg:w-[100%] w-full lg:mr-5 mb-2 lg:mb-0">
                        <InputBase
                          placeholder="Recording name"
                          value={recording_data.title}
                          onChange={(e) =>
                            setRecordingData({ ...recording_data, title: e.target.value })
                          }
                          sx={{
                            bgcolor: "#F7F7F8",
                            width: "100%",
                            px: 2,
                            fontSize: "14px",
                          }}
                        />
                      </div>


                    </div>
                  </div>
                </div>
              )}

              <div className="flex justify-center  pb-4 space-x-2">
                <Button
                  disabled={(forward_action === 2 &&
                    (loader || (record_type === 'upload_mp3' && !uploadedFile) ||
                      (record_type === 'record_now' && !audioBlob))) || (forward_action === 1 && forward_number.length <= 1)
                    ? true
                    : false}
                  sx={{
                    textTransform: "none",
                    bgcolor: "#605BFF",
                    color: "white",
                    py: "6px",
                    px: "30px",
                    borderRadius: "7px",
                    fontSize: { lg: "14px", xs: "13px" },
                    width: "fit",
                  }}
                  onClick={() => {
                    localStorage.setItem("cameFromRegister", "true");
                    if (forward_action === 1) {
                      if (code === verificationCodeConfirmation) {
                        completeOnboardingforFowardedCall();
                        setErrormsg(null)
                        setErrorMsg(null)
                      } else {
                        setErrormsg("The verification code does not match, please verify number.");
                        window.scrollTo({
                          top: 0,
                          behavior: "smooth",
                        });
                      }
                    } else {
                      if (recording_data.title.length < 1) {
                        setErrormsg('no record title')
                      } else {
                        completeOnboardingforFowardedCall();
                        setErrormsg(null)
                        setErrorMsg(null)
                      }

                    }
                  }}
                >
                  {loader ? (
                    <CircularProgress size={"1.3rem"} sx={{ color: "white" }} />
                  ) : (
                    " Next"
                  )}
                </Button>
              </div>
            </div>
          )}
        </div>

        <div className="col-span-3 lg:flex justify-center my-auto hidden ">
          {step === 1 && (
            <img
              src="/icons/illustration.png"
              className=" w-[580px] h-[500px] "
            />
          )}

          {step === 2 && (
            <img
              src="/icons/illustration.png"
              className=" w-[580px] h-[500px] "
            />
          )}

          {step === 3 && (
            <div>
              <div className="text-center lg:text-[18px] text-[15px] font-[500] mb-3">
                How to configure Twilio
              </div>
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/f3LKG7kBq74?si=o_QpCRkdK9mfenlx"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>

              <div className="text-black text-center lg:text-[13px]   text-[12px] mt-[80px]">
                More info on our{" "}
                <span className="text-[#605BFF] cursor-pointer hover:underline  "
                 onClick={()=> {
                  window.open('https://twilanswer.com/docs/how-to-integrate-twilio-with-twilanswer/', '_blank')
                }}
                >
                  help page
                </span>
              </div>
            </div>
          )}

          {step === 4 && (
            <div>
              <div className="text-center lg:text-[18px] text-[15px] font-[500] mb-3">
                Forward Action Option
              </div>
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/Hn1-di--OCI?si=QKqwFXLiHLRHqEcB"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>

              <div className="text-black text-center lg:text-[13px]   text-[12px] mt-[80px]">
                More info on our{" "}
                <span className="text-[#605BFF] cursor-pointer hover:underline  "
                 onClick={()=> {
                  window.open('https://twilanswer.com/docs/how-to-create-a-twilanswer-account/', '_blank')
                }}
                >
                  help page
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Register;
